var map = {
	"./add1.png": "9oL5",
	"./all_ddjs.png": "/5HE",
	"./all_hd.png": "paeB",
	"./all_tc.png": "kjg0",
	"./all_xq.png": "XHmV",
	"./all_yhq.png": "zEEA",
	"./all_yxj.png": "jOl1",
	"./all_zwh.png": "BmLV",
	"./an.png": "vgHQ",
	"./banner_left.png": "yTRE",
	"./banner_right.png": "jXic",
	"./bj@2x.png": "+Z75",
	"./cgqd(1).png": "0kaX",
	"./close1.png": "pDIl",
	"./commodity_left.png": "yWSz",
	"./commodity_left02.png": "DY96",
	"./commodity_right.png": "WqSZ",
	"./commodity_right02.png": "mj6l",
	"./d_smtj.png": "LG1m",
	"./defaultgraph.png": "uL+b",
	"./defaultimg.png": "tzCM",
	"./dingd.png": "Ev42",
	"./dis1.png": "geTB",
	"./gouwuc.png": "cR/Z",
	"./hdx.png": "eyJ3",
	"./icon_1.png": "WEuK",
	"./icon_2.png": "ifDj",
	"./icon_3.png": "2dow",
	"./icon_alipay.png": "ulA/",
	"./icon_az@2x.png": "K5sM",
	"./icon_c1.png": "NNlr",
	"./icon_c2.png": "3cDr",
	"./icon_caigou.png": "Nz7T",
	"./icon_ccenter.png": "HDrk",
	"./icon_ccoupons.png": "6F/y",
	"./icon_cgdjd.png": "/qSi",
	"./icon_chart.png": "QMrb",
	"./icon_classification.png": "sh0L",
	"./icon_cmycoupons.png": "BR1a",
	"./icon_cmyorder.png": "Qmtg",
	"./icon_collection.png": "psCW",
	"./icon_collection2.png": "GINz",
	"./icon_coupon_bg.png": "4329",
	"./icon_coupon_bg2.png": "7AYw",
	"./icon_coupons.png": "NutK",
	"./icon_d1.png": "K3Wb",
	"./icon_d2.png": "RWFy",
	"./icon_dh.png": "s+8h",
	"./icon_discount.png": "qTUD",
	"./icon_download.png": "wqNP",
	"./icon_f01.png": "E746",
	"./icon_f02.png": "FwmF",
	"./icon_f03.png": "SB8M",
	"./icon_g.png": "Ueqm",
	"./icon_gonggao.gif": "PeoR",
	"./icon_goods.png": "t/ZN",
	"./icon_goods1.png": "kmuJ",
	"./icon_ios@2x.png": "x7AZ",
	"./icon_logo.png": "YS2w",
	"./icon_logo3.png": "+nIz",
	"./icon_more.png": "mYqV",
	"./icon_more2.png": "9aIK",
	"./icon_number.png": "IjyX",
	"./icon_offer.png": "1S0Q",
	"./icon_p1.png": "KS1Y",
	"./icon_p2.png": "ZKRK",
	"./icon_paid.png": "7d4p",
	"./icon_password.png": "rEaC",
	"./icon_pc@2x.png": "simE",
	"./icon_phone.png": "jU7V",
	"./icon_postage.png": "QOhu",
	"./icon_province.png": "t2BD",
	"./icon_qrcode.png": "IfFH",
	"./icon_receivinggoods.png": "ePuh",
	"./icon_reduction.png": "CKtO",
	"./icon_refundt.png": "S0pt",
	"./icon_ren.png": "x24f",
	"./icon_return.png": "KLBr",
	"./icon_s1.png": "KNRE",
	"./icon_s2.png": "lb9c",
	"./icon_search.png": "3rhe",
	"./icon_search2.png": "HWJW",
	"./icon_selected.png": "0LZm",
	"./icon_server.png": "RX3x",
	"./icon_shopping-white.png": "RerE",
	"./icon_shopping.png": "08it",
	"./icon_slfdjsk.png": "9pK8",
	"./icon_success.png": "JsnA",
	"./icon_successx.png": "EDJ+",
	"./icon_time.png": "v35C",
	"./icon_top.png": "virk",
	"./icon_uploadpictures.png": "RHN3",
	"./icon_wechat.png": "cXQJ",
	"./icon_x.png": "5OVm",
	"./icon_xx1.png": "T9aw",
	"./icon_xx2.png": "vou2",
	"./icon_xx3.png": "ENaP",
	"./icon_xz@2x.png": "HgoE",
	"./list_delete@2x.png": "LWIu",
	"./login_bg.png": "aF6v",
	"./logo/app_ewm.png": "D5BS",
	"./logo/b1.png": "1Zo5",
	"./logo/b10.png": "vtOD",
	"./logo/b11.png": "EPfa",
	"./logo/b12.png": "fkdg",
	"./logo/b2.png": "xwiN",
	"./logo/b3.png": "NN0U",
	"./logo/b4.png": "dnxV",
	"./logo/b5.png": "KIyP",
	"./logo/b6.png": "XH5d",
	"./logo/b7.png": "3usO",
	"./logo/b8.png": "vOga",
	"./logo/b9.png": "5Pco",
	"./logo/icon_logo2.png": "0bDm",
	"./logo/logo@2x.png": "O9CT",
	"./logo/vx_ewm.png": "rU88",
	"./payment_g.png": "svKL",
	"./seckill_banner.png": "wTqp",
	"./shouc.png": "I1Tx",
	"./sousuo.png": "5UXQ",
	"./sx.png": "cxWy",
	"./sxx.png": "p4Y7",
	"./t_s.png": "l2pE",
	"./wxzf.png": "RvDi",
	"./x.png": "VgmL",
	"./x_smtj.png": "jbvo",
	"./xxxx2_xxhdpi.png": "A+AQ",
	"./xxxx_xxhdpi.png": "x5AQ",
	"./yg.png": "h+j1",
	"./yhq.png": "QvK7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "g2Y0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*$
// module id = g2Y0
// module chunks = 1